module.exports = __webpack_public_path__ + "img/2.dd76437e.png";